// src/utils/avatar.js
export function getAvatarUrl(data, baseUrl = 'http://ispace.front.yuugeai.com/api/uploads') {
  // 获取头像字段（兼容不同来源的数据结构）
  const avatarField = data.avatar || data.user_avatar || data.business_avatar || data.avatarUrl || data.head_img;
  
  // 如果没有头像字段，返回null
  if (!avatarField) return null;

  // 处理绝对路径和相对路径
  if (avatarField.startsWith('http://') || avatarField.startsWith('https://')) {
    return avatarField;
  }
  
  // 处理data:image格式的base64图片
  if (avatarField.startsWith('data:image/')) {
    return avatarField;
  }
  
  // 相对路径拼接基础URL
  return `${baseUrl}${avatarField.startsWith('/') ? '' : '/'}${avatarField}`;
}

// 获取默认头像URL
export function getDefaultAvatarUrl() {
  return require('@/views/chating/assets/img/default-avatar.png');
}

// 验证头像URL是否有效
export function isValidAvatarUrl(url) {
  if (!url) return false;
  
  // 检查是否是有效的URL格式
  try {
    new URL(url);
    return true;
  } catch {
    // 如果不是完整URL，检查是否是相对路径或base64
    return url.startsWith('/') || url.startsWith('data:image/');
  }
}